import axios from 'axios';
import api from '../../../config/api.routes';
import authHeader from '../../../services/auth-header';

const list = (data) => {
  let url = api().apiURL + '/coupangProduct/list?';
  for (const query of Object.keys(data)) {
    if (data[query] === undefined || data[query] === '') {
      continue;
    }
    url += `${query}=${data[query]}&`;
  }

  return new Promise((resolve, reject) => {
    axios.get(url, { headers: authHeader() })
      .then((res) => res.data)
      .then((res) => resolve(res))
      .catch((e) => reject(e));
  });
};

const detail = (id) => {
  const url = api().apiURL + `/coupangProduct/detail?id=${id}`;
  return new Promise((resolve, reject) => {
    axios.get(url, { headers: authHeader() })
      .then((res) => res.data)
      .then((res) => resolve(res))
      .catch((e) => reject(e));
  });
};

const register = (data) => {
  const url = api().apiURL + '/coupangProduct/register';
  return new Promise((resolve, reject) => {
    axios.post(url, data, { headers: authHeader() })
      .then((res) => res.data)
      .then((res) => resolve(res))
      .catch((e) => reject(e));
  });
};

const update = (id, data) => {
  const url = api().apiURL + `/coupangProduct/update?id=${id}`;
  return new Promise((resolve, reject) => {
    axios.put(url, data, { headers: authHeader() })
      .then((res) => res.data)
      .then((res) => resolve(res))
      .catch((e) => reject(e));
  });
};

const remove = (id) => {
  const url = api().apiURL + `/coupangProduct/remove?id=${id}`;
  return new Promise((resolve, reject) => {
    axios.delete(url, { headers: authHeader() })
      .then((res) => res.data)
      .then((res) => resolve(res))
      .catch((e) => reject(e));
  });
};

const fileRegister = (id, data) => {
  const url = api().apiURL + `/coupangProduct/file/register?coupangProductId=${id}`;
  return new Promise((resolve, reject) => {
    axios.post(url, data, { headers: authHeader() })
      .then((res) => res.data)
      .then((res) => resolve(res))
      .catch((e) => reject(e));
  });
};

const coupangProductService = {
  list,
  detail,
  register,
  update,
  remove,
  fileRegister,
};

export default coupangProductService;
